const initialState = {
    data:null
};

export default function (state = initialState, action) {
    switch (action.type) {
        case "SET_GENERAL_DATA":
            return {
                ...state,
                data:action.data
            }
        default:
            return state;
    }
}
